import React from "react";
import Projects from "./Projects";

const lists = [
  {
    id: Math.random(),
    name: "Project 1",
    description: `eius, et, obcaecati impedit ea dolorem reprehenderit eum nulla
        voluptate fugiat qui amet hic beatae itaque similique ratione
        officia sequi velit!`,
    imglink: "#45",
  },
  {
    id: Math.random(),
    name: "Project 2",
    description: `eius, et, obcaecati impedit ea dolorem reprehenderit eum nulla
        voluptate fugiat qui amet hic beatae itaque similique ratione
        officia sequi velit!`,
    imglink: "#45",
  },
  {
    id: Math.random(),
    name: "Project 3",
    description: `eius, et, obcaecati impedit ea dolorem reprehenderit eum nulla
        voluptate fugiat qui amet hic beatae itaque similique ratione
        officia sequi velit!`,
    imglink: "#45",
  },
  {
    id: Math.random(),
    name: "Project 4",
    description: `eius, et, obcaecati impedit ea dolorem reprehenderit eum nulla
        voluptate fugiat qui amet hic beatae itaque similique ratione
        officia sequi velit!`,
    imglink: "#45",
  },
  {
    id: Math.random(),
    name: "Project 5",
    description: `eius, et, obcaecati impedit ea dolorem reprehenderit eum nulla
        voluptate fugiat qui amet hic beatae itaque similique ratione
        officia sequi velit!`,
    imglink: "#45",
  },
];

const ProjectList = () => {

    const value = lists.map((list) => {
        <Projects
          key={list.id}
          name={list.name}
          description={list.description}
          imglink={list.imglink}
        />;
      })

  return (
    <>
      {value}
    </>
  );
};

export default ProjectList;
